import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import { urls } from '../config'
import { FINANCE_API } from '@/modules/banking/constants'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconCashJournal from '@assets/images/icons/cashbook.svg'
import IconCashJournalPos from '@assets/images/icons/cashJournal.svg'
import IconTransfer from '@assets/images/icons/transfer.svg'
import ShopifyIcon from '@assets/images/banking/shopify.svg'

const {
  CASH_JOURNAL,
  CLEARING_ACCOUNT,
  CASH_JOURNAL_POS,
  CLEARING_ACCOUNT_POS,
  CLEARING_ACCOUNT_PAYPAL,
  SHOPIFY_POS,
} = FINANCE_API.ACCOUNT_TYPE

const prepareImageSource = (url) => {
  return url.startsWith('http')
    ? url
    : `${urls.resource}${url}`
}

const useStyles = makeStyles((theme) => ({
  logo: {
    '& > *': {
      fill: theme.icons.base,
    },
  },
}))

const BankingLogo = (props) => {
  const classes = useStyles()
  const {
    url,
    height,
    width,
    className,
    accountType,
  } = props

  if (!url) {
    return null
  }

  const src = prepareImageSource(url)
  const styleProps = { className, height, width }

  switch (accountType) {
    case CASH_JOURNAL:
      return <SVGIcon className={clsx(className, classes.logo)} svg={IconCashJournal} height={height} width={height} />
    case CASH_JOURNAL_POS:
      return <SVGIcon className={clsx(className, classes.logo)} svg={IconCashJournalPos} height={height} width={height} />
    case CLEARING_ACCOUNT:
    case CLEARING_ACCOUNT_POS:
    case CLEARING_ACCOUNT_PAYPAL:
      return <SVGIcon className={clsx(className, classes.logo)} svg={IconTransfer} height={height} width={height} />
    case SHOPIFY_POS:
      return <SVGIcon className={clsx(className)} svg={ShopifyIcon} height={height} width={height} />
    default:
      return <img style={{ display: 'inline-block' }} src={src} {...styleProps} />
  }
}

BankingLogo.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  url: PropTypes.string,
  accountType: PropTypes.string,
}
BankingLogo.defaultProps = {
  height: '16px',
  width: undefined,
  accountType: '',
}

export default BankingLogo
